import { action, makeObservable, observable, observe } from 'mobx';
import { getResellers, getSubscriptions } from '../api/admin';
import AuthStore from './AuthStore';
import Reseller from '../model/reseller';
import { AdminSubscription } from '../model/subscription';

const PAGE_SIZE = 10;

class SubscriptionsAdminStore {
  subscriptions: AdminSubscription[] = [];

  resellers: { [Key: string]: Reseller } = {};

  loading = false;

  endReached = false;

  authStore: AuthStore;

  constructor(authStore: AuthStore) {
    this.authStore = authStore;

    makeObservable(this, {
      subscriptions: observable,
      resellers: observable,
      loading: observable,
      fetchInitial: action,
    });

    observe(authStore, 'isAdmin', () => {
      if (authStore.user && authStore.isAdmin) {
        this.fetchInitial();
      }
    });
  }

  fetchInitial = async (): Promise<void> => {
    this.loading = true;
    this.endReached = false;
    this.subscriptions = await getSubscriptions(PAGE_SIZE);
    if (this.subscriptions.length < PAGE_SIZE) {
      this.endReached = true;
    }

    this.resellers = await getResellers();

    this.loading = false;
  };

  fetchMore = async (): Promise<void> => {
    if (this.loading || this.endReached) {
      return;
    }
    this.loading = true;
    const newSubscriptions = await getSubscriptions(PAGE_SIZE, this.subscriptions.length);
    this.subscriptions.push(...newSubscriptions);
    if (newSubscriptions.length < PAGE_SIZE) {
      this.endReached = true;
    }
    this.loading = false;
  };

  refresh() {
    if (this.loading) {
      return;
    }
    this.subscriptions = [];
    this.resellers = {};
    this.fetchInitial();
  }
}

export default SubscriptionsAdminStore;
